var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",class:_vm.classes,style:(_vm.customStyle)},'component',_vm.tagProps,false),_vm.$listeners),[(_vm.loading)?_c('span',{class:[
            'inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin',
            _vm.hasSlot ? 'mr-1.5' : ''
        ]}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }